import React, { memo, useEffect, useRef } from "react";
import useData from "../../hooks/useData";
import useMessage, { MESSAGE_TYPES } from "../../hooks/useMessage";
import inPreview from "../../utils/inPreview";
import message from "../../utils/message";

const EMPTY_NURTURE_OFFER = {
	incentive_code: "PROMOCODE",
	incentive_heading: "Discount value",
	incentive_subheading: "Details about your discount",
	incentive_remote_id: "abcdefg",
	incentive_landing_page_url: null,
	incentive_type: "promo_code",
};

// TODO: Dynamic field handler concept
// const HANDLER_TYPE_MAPPING = {
// 	NURTURE_OFFER: (data, updatedData) => ({
// 		...data,
// 		brands: [
// 			{ ...data.brands[0], ...updatedData },
// 			...data.brands.slice(1),
// 		],
// 	}),
// 	PUBLISHER_DETAILS: (data, updatedData) => ({
// 		...data,
// 		publisher_details: { ...data.publisher_details, ...updatedData },
// 	}),
// };

const PreviewManager = memo(({ children }) => {
	const { setData, ...data } = useData();
	const hasMounted = useRef(false);

	useEffect(() => {
		if (!inPreview || hasMounted.current || !data?.brands) return;
		hasMounted.current = true;
		const hasNurtureOffer = !!data?.brands?.[0]?.incentive_heading;

		setData((prevData) => ({
			...prevData,
			brands: hasNurtureOffer
				? prevData.brands
				: [
						{ ...prevData.brands[0], ...EMPTY_NURTURE_OFFER },
						...prevData.brands.slice(1),
				  ],
			previewMeta: {
				hasNurtureOffer,
			},
		}));
		message(MESSAGE_TYPES.PLATFORM_FETCH_CACHED_MESSAGES);
	}, [data, setData]);

	const handleMessage = (payload) => {
		if (!inPreview) return;
		// TODO: Add more dynamic functionality to which fields are updated here
		setData((data) => ({
			...data,
			brands: [
				{ ...data.brands[0], ...payload },
				...data.brands.slice(1),
			],
		}));
	};
	useMessage(MESSAGE_TYPES.PLATFORM_DATA_TRANSFER, handleMessage);

	return children;
});

export default PreviewManager;
